import React, { useId } from 'react';

import { IconComponent } from '../../Icons/helpers';
import { InputControl } from '../components/InputControl';
import { InputField } from '../components/InputField';
import { InputFieldBody } from '../components/InputFieldBody';
import { InputFieldStartIcon } from '../components/InputFieldStartIcon';
import { InputFieldClearButton } from '../components/InputFieldClearButton';
import {
  ClearButtonFeature,
  CharacterCounterFeature,
  FormProps,
  CommonInputProps,
} from '../types';

type InputTextProps = {
  startIcon?: IconComponent;
} & CommonInputProps &
  CharacterCounterFeature &
  ClearButtonFeature &
  FormProps;

const InputText = (props: InputTextProps) => {
  const id = useId();
  const {
    name,
    placeholder,
    error,
    disabled,
    helpText,
    extraHelpText,
    label,
    startIcon,
    autoFocus,
    hasCharacterCounter,
    hasClearButton,
    maxLength,
    validations = {},
    formHooks: { register, watch, resetField },
    condensed,
  } = props;
  const value = watch && watch(name);
  const showClearButton = Boolean(hasClearButton && value);
  const hasLengthError = maxLength ? Number(value?.length) > maxLength : false;

  if (!validations?.maxLength) validations.maxLength = maxLength;

  return (
    <InputControl
      error={error}
      helpText={helpText}
      extraHelpText={extraHelpText}
      value={value}
      hasCharacterCounter={hasCharacterCounter}
      maxLength={maxLength}
      label={label}
      htmlFor={id}
      condensed={condensed}
    >
      <InputField
        hasError={Boolean(error) || hasLengthError}
        disabled={disabled}
        paddingLeft={startIcon ? '5px' : '11px'}
        paddingRight={showClearButton ? '5px' : '11px'}
      >
        {startIcon && (
          <InputFieldStartIcon disabled={disabled} icon={startIcon} />
        )}
        <InputFieldBody
          disabled={disabled}
          autoFocus={autoFocus}
          placeholder={placeholder}
          register={register}
          id={id}
          name={name}
          validations={validations}
        />
        {showClearButton && (
          <InputFieldClearButton
            onClick={() => resetField?.(name)}
            disabled={disabled}
            align="center"
          />
        )}
      </InputField>
    </InputControl>
  );
};

export { InputText };
